// extracted by mini-css-extract-plugin
export var active = "_86-1";
export var activeSubdued = "_86-2";
export var compact = "_86-3";
export var fill = "_86-6";
export var pulse = "_86-4";
export var settingHighlightPulse = "_86-5";
export var wrapper = "_86-0";